export const PAYONEER_SAVE_ACCESS_TOKEN_SUCCESS = 'PAYONEER_SAVE_ACCESS_TOKEN_SUCCESS';
export const PAYONEER_PAYONEER_SAVE_ACCESS_TOKEN_FAILED = 'PAYONEER_PAYONEER_SAVE_ACCESS_TOKEN_FAILED';
export const PAYONEER_SAVE_ACCESS_TOKEN_FETCH = 'PAYONEER_SAVE_ACCESS_TOKEN_FETCH';
